/* Türkçe çeviriler */
const tr = {
  lang: 'tr',
  langLabel: 'Türkçe',
  login: {
    welcome: 'Tekrar hoş geldiniz',
    subtitle: 'Atunears panelinize giriş yapın.',
    email: 'E-posta',
    emailPlaceholder: 'ornek@atunears.com',
    password: 'Şifre',
    passwordPlaceholder: '••••••••',
    showPassword: 'Şifreyi göster',
    hidePassword: 'Şifreyi gizle',
    rememberMe: 'Beni hatırla',
    forgotPassword: 'Şifremi unuttum',
    submit: 'Giriş Yap',
    submitting: 'Giriş yapılıyor…',
    noAccount: 'Hesabınız yok mu?',
    contactUs: 'Lütfen bizimle iletişime geçin.',
    tagline: 'Kişiye Özel Ses Deneyimi',
    heroTitle: '<em>Kulağınıza özel </em>frekanslar.<br/><em>Size özel</em> kulaklıklar.',
    heroDesc: 'Atunears panelinizden kişisel ses imzanızı, sipariş takibinizi ve kulak kalıbı randevularınızı tek bir yerden yönetin.',
    feature1: 'Kişisel kulak kalıbı & ses imzası',
    feature2: 'El yapımı, ısmarlama kasalar',
    feature3: 'Sipariş ve randevu paneli',
  },
  topbar: {
    adminPanel: 'Admin Paneli',
    adminPanelSub: 'Customer kapsamındaki kullanıcı, form ve atamaları yönetin.',
    userPanel: 'Kullanıcı Paneli',
    userPanelSub: 'Atanmış formlarınızı doldurun ve gönderim geçmişinizi takip edin.',
    refresh: 'Yenile',
    lightMode: 'Açık moda geç',
    darkMode: 'Koyu moda geç',
  },
  sidebarUser: {
    myForms: 'Formlarım',
    newForm: 'Yeni Form',
    sentForms: 'Gönderdiğim Formlar',
  },
  sidebarAdmin: {
    formManagement: 'Form Yönetimi',
    addForm: 'Form Ekle',
    listForms: 'Form Listele',
    moldTypes: 'Kalıp Yönetimi',
    users: 'Kullanıcı',
    userManagement: 'Kullanıcı Yönetimi',
    data: 'Veri',
    submissions: 'Gönderimler',
    kanban: 'Kanban',
    editForm: 'Form Düzenle',
  },
  userForms: {
    noMoldTitle: 'Henüz bir kalıp tanımlanmadı',
    noMoldDesc: 'Yöneticiniz kalıpları tanımladığında bu alanda otomatik olarak görünecektir. Sorularınız için lütfen yöneticinizle iletişime geçin.',
    secureConnection: 'Güvenli bağlantı',
    chooseMoldLabel: 'Kalıp seçimi',
    chooseMoldTitle: 'Doldurmak istediğiniz kalıbı seçin',
    chooseMoldSub: (n) => `${n} farklı kalıp arasından seçim yapabilirsiniz. Devam etmek için aşağıdan birini seçin.`,
    selectedMoldLabel: 'Seçili kalıp',
    moldList: 'Kalıp listesi',
    loadingForm: 'Form yükleniyor…',
    footerSecure: 'Bilgileriniz şifreli bağlantı üzerinden iletilir.',
    footerPlatform: 'Atunears Form Platformu',
  },
  userSubmissions: {
    title: 'Gönderdiğim Formlar',
    subtitle: 'Gönderimlerinizi form adı, status ve tarih aralığıyla filtreleyin.',
    formNameLabel: 'Form adı',
    formNamePlaceholder: 'Form ara',
    statusLabel: 'Status',
    all: 'Tümü',
    dateFrom: 'Başlangıç',
    dateTo: 'Bitiş',
    records: (n) => `${n} kayıt`,
    noResults: 'Filtreye uygun gönderim bulunamadı.',
    colForm: 'Form',
    colStatus: 'Status',
    colDate: 'Gönderim',
    inspect: 'İncele',
    submittedAt: 'Gönderim tarihi',
    downloadPdf: 'PDF İndir',
    filesTitle: (n) => `Ekli Dosyalar (${n})`,
    clearAllFiles: 'Tümünü Temizle',
    clearing: 'Siliniyor…',
  },
  submissions: {
    title: 'Gönderimler',
    subtitle: 'Filtreleyin ve tabloda inceleyin. Statü değiştirmek için Kanban ekranını kullanın.',
    records: (shown, total) => `${shown} / ${total} kayıt`,
    filtersLabel: 'Filtreler',
    clearFilters: 'Temizle',
    searchPlaceholder: 'Form, kullanıcı veya status ile ara…',
    searchLabel: 'Arama',
    dateFrom: 'Başlangıç',
    dateTo: 'Bitiş',
    formsGroup: 'Formlar',
    usersGroup: 'Kullanıcılar',
    statusesGroup: 'Statüler',
    colForm: 'Form',
    colUser: 'Kullanıcı',
    colStatus: 'Status',
    colSubmitted: 'Gönderim',
    colUpdated: 'Güncellenme',
    colActions: 'İşlemler',
    noResults: 'Filtrelerle eşleşen gönderim yok.',
    download: 'İndir',
    downloading: 'Hazırlanıyor…',
    exportExcel: "Excel'e Aktar",
    exportExcelHint: 'Filtreye uyan kayıtları Excel dosyası olarak indirir',
    downloadPdf: 'PDF İndir',
    clearFiles: 'Temizle',
    inspect: 'İncele',
    noFiles: 'Bu göndertimde indirilebilecek dosya yok.',
    confirmClear: "Bu gönderimin tüm dosyaları S3'ten kalıcı olarak silinecek. Devam edilsin mi?",
    delete: 'Sil',
    deleteSubmission: 'Gönderimi Sil',
    deleting: 'Siliniyor…',
    confirmDelete: 'Bu gönderim, tüm yanıtları ve ekli dosyalarıyla birlikte kalıcı olarak silinecek. Geri alınamaz. Devam edilsin mi?',
    kanbanEmpty: 'Buraya sürükleyin',
    noStatuses: 'Henüz tanımlı status yok.',
    statusLabel: 'Status',
    filesTitle: (n) => `Ekli Dosyalar (${n})`,
    clearAllFiles: 'Tümünü Temizle',
    clearing: 'Siliniyor…',
    selectPlaceholder: 'Form seçin',
    userSelectPlaceholder: 'Kullanıcı seçin',
    noFormOptions: 'Form bulunamadı',
    noUserOptions: 'Kullanıcı bulunamadı',
    searchInDropdown: 'Ara…',
    noDropdownResults: 'Sonuç yok',
    selectedCount: (n) => `${n} seçili`,
    clearSelection: 'Seçimi temizle',
    completedToggleGroup: 'Tamamlananlar',
    showCompleted: 'Tamamlananları göster',
    kanbanTitle: 'Sipariş Kanbanı',
    kanbanSubtitle: 'Siparişleri sürükle-bırak ile statüler arasında taşıyın. Tamamlanan siparişler varsayılan olarak gizlenir.',
  },
  moldTypes: {
    title: 'Kalıp Yönetimi',
    subtitle: 'Kullanıcıların form doldurmadan önce seçeceği kalıpları yükleyin ve dile göre formlarını ilişkilendirin.',
    newMold: 'Yeni Kalıp',
    newMoldDefaultName: 'Yeni Kalıp',
    noMolds: 'Henüz kalıp tanımlanmadı. "Yeni Kalıp" ile başlayın.',
    selectMoldHint: 'Düzenlemek için soldan bir kalıp seçin.',
    uploadImage: 'Görsel yükle',
    uploading: 'Yükleniyor…',
    uploadError: 'Görsel yüklenirken hata oluştu.',
    active: 'Aktif',
    inactive: 'Pasif',
    deleteMold: 'Kalıbı sil',
    confirmDelete: (name) => `"${name}" kalıbı silinsin mi? Bağlı formlar silinmez, yalnızca ilişki kaldırılır.`,
    moldNameTitle: 'Dile Göre Kalıp Adı',
    moldNameHint: 'Kullanıcılar kalıbı kendi dillerindeki adla görür. Türkçe zorunludur; İngilizce ve Almanca opsiyoneldir.',
    moldNamePlaceholderRequired: 'ör. Tam Konka',
    moldNamePlaceholderOptional: 'Çeviri girilmezse Türkçe ad kullanılır',
    required: 'zorunlu',
    languageFormsTitle: 'Dile Göre Formlar',
    languageFormsHint: 'Her dil için ayrı bir form seçin. Türkçe önerilir; İngilizce ve Almanca zorunlu değildir.',
    recommended: 'önerilir',
    pickForm: 'Form seçin',
    removeLink: 'İlişkiyi kaldır',
  },
  common: {
    loading: 'Yükleniyor…',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    close: 'Kapat',
    yes: 'Evet',
    no: 'Hayır',
  },
  sidebar: {
    logout: 'Çıkış',
    collapse: 'Daralt',
    expand: 'Genişlet',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
  },
  // Backend status code'larının çevirisi — bilinmeyen kod gelirse fallback ad gösterilir
  statuses: {
    Forwarded: 'İletildi',
    InProduction: 'Üretimde',
    Shipped: 'Kargoya Verildi',
  },
};

export default tr;
